import {Button, Dropdown, Flex, MenuProps, Space} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleDown, faBolt, faGear} from "@fortawesome/free-solid-svg-icons";
import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {setModel} from "../../feature/project/draftSlice";
import {AIProvider, AIProviderSettings, providers} from "../providers/AIProvider";
import {MenuItemType} from "antd/es/menu/interface";

export const aiIcon = <FontAwesomeIcon icon={faBolt}/>
export const ModelsMenu = (
    props: {}
) => {
    const dispatch = useAppDispatch()
    const aiProviders = useAppSelector(state => state.aiSlice.aiProviderSettings)
    const projectAiProviders = useAppSelector(state => state.aiSlice.projectAiProviderSettings)
    const model = useAppSelector(state => state.draftSlice.model)
    const [canGenerate, setCanGenerate] = React.useState(false)
    const user = useAppSelector(state => state.users.currentUser)

    useEffect(() => {
        const enabledProviders = aiProviders.filter(p => p.enabled).map(p => p.name)
        const selectedProviders = projectAiProviders.filter(p => p.enabled).filter(p => enabledProviders.includes(p.name) || user?.role != 'creator')
        setCanGenerate(selectedProviders.map(p => p.models).flat().length > 0)
    }, [aiProviders, projectAiProviders])

    const modelsMenu: MenuProps = {
        selectable: true,
        defaultSelectedKeys: [model],
        items: projectAiProviders.flat()
            .sort((s1, s2) => {
                const p1 = providers.find(p => p.name == s1.name)
                const p2 = providers.find(p => p.name == s2.name)
                return (p1?.priority ?? 0) - (p2?.priority ?? 0)
            })
            .filter(s => s.enabled && s.models.length > 0)
            .map(s =>
                [{
                    key: s.name,
                    label: <Flex
                        gap={10}
                        align={'center'}
                        className={'models-menu-item'}
                    >{s.name.toUpperCase()}</Flex>,
                    disabled: true
                } as MenuItemType].concat(
                    s.models.map(m => ({key: m, label:m} as MenuItemType))
                )
            ).flat(),

    }

    useEffect(() => {
        if (projectAiProviders) {
            const newModel = getModel(model, projectAiProviders)
            if (newModel != model) {
                dispatch(setModel({model: getModel(model, projectAiProviders)}))
            }
        }
    }, [projectAiProviders, model]);

    return (
        <>
            {canGenerate ?
                <Dropdown
                    rootClassName={'models-menu'}
                    trigger={["click"]}
                    menu={{
                        items: modelsMenu.items, selectable: true, defaultSelectedKeys: [model],
                        onSelect: (item) => {
                            dispatch(setModel({model: item.key}))
                        }
                    }}
                >
                    <Button style={{width: '100%'}}>

                        <Flex align={'center'}
                              gap={10}
                              justify={'space-between'}> {model ?
                            <Flex
                                gap={10}
                                align={'center'}
                                className={'models-menu-item'}
                            >
                                {(getProviderByModel(model)?.icon ?? '')}{(modelsMenu.items?.find((item) => item?.key == model) as MenuItemType)?.label}
                            </Flex> : "Select Name"}
                            <FontAwesomeIcon icon={faAngleDown}/></Flex>
                    </Button>
                </Dropdown>
                : ''}
        </>
    )
}

const getProviderByModel = (model: string): AIProvider | undefined => {
    return providers.find(p => p.models.includes(model))
}

const getModel = (model: string, settings: AIProviderSettings[]): string => {
    const models = settings.flat()
        .sort((s1, s2) => {
            const p1 = providers.find(p => p.name == s1.name)
            const p2 = providers.find(p => p.name == s2.name)
            return (p1?.priority ?? 0) - (p2?.priority ?? 0)
        })
        .map(s => s.models)
        .flat()
    if (models.length == 0) {
        return ''
    }
    if (models.includes(model)) {
        return model
    } else {
        return models[0]
    }
}